function classNames(classObject, breakpoints = {}) {
    const classes = Object.entries(classObject)
        .filter(([, value]) => value)
        .map(([key]) => key);
    const breakpointClasses = Object.entries(breakpoints)
        .map(([key, value]) => value.reduce((acc, v) => `${acc} ${key}@${v}`, ''));
    return [...classes, ...breakpointClasses].join(' ');
}
export default classNames;
//# sourceMappingURL=class-names.js.map